/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-29 15:45:16
 */
import { Dropdown, Menu } from "antd";
import { connect } from "react-redux";
import { setLanguage } from "@/redux/modules/global/action";
import { DownOutlined } from "@ant-design/icons";
import { updateLocale } from "@/api/modules/user";
import { MenuProps } from "antd/es/menu/hooks/useItems";

const languageEnum = {
	en_US: "English",
	zh_CN: "简体中文"
};

const Language = (props: { language: "en_US" | "zh_CN"; setLanguage: any }) => {
	const { language, setLanguage } = props;

	const items: MenuProps["items"] = [
		{
			key: "en_US",
			label: <span className="dropdown-item">English</span>,
			onClick: () => {
				setLanguage("en_US");
				updateLocale({ locale: "en_US" }).then(res => {
					if (res.code === 200) {
						console.log("切换成功");
					}
				});
			},
			disabled: language === "en_US"
		},
		{
			key: "zh_CN",
			label: <span className="dropdown-item">简体中文</span>,
			onClick: () => {
				setLanguage("zh_CN");
				updateLocale({ locale: "zh_CN" }).then(res => {
					if (res.code === 200) {
						console.log("切换成功");
					}
				});
			},
			disabled: language === "zh_CN"
		}
	];


	return (
		<>
			<Dropdown menu={{items}} placement="bottom" trigger={["click"]} arrow={true}>
				<div style={{ background: "#F7F8FA", borderRadius: 18, lineHeight: "30px", height: 30, padding: "0 10px" }}>
					<span style={{ marginRight: "1rem" }}>{languageEnum[language]}</span>
					<DownOutlined />
				</div>
			</Dropdown>
		</>
	);
};

const mapStateToProps = (state: any) => state.global;
const mapDispatchToProps = { setLanguage };
export default connect(mapStateToProps, mapDispatchToProps)(Language);
